import axios from 'axios'

const client = axios.create({
  baseURL: (process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : process.env.REACT_APP_API_URL || 'http://localhost:5000') + '/api', // Force localhost in dev or use env var
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to every request
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Handle 401 → auto logout (but not DB/server outages)
client.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const code = err.response?.data?.code;

    if (status === 503 || code === 'DB_UNAVAILABLE') {
      return Promise.reject(err);
    }

    if (status === 401) {
      const path = window.location.pathname;
      const isAuthPage = path === '/login' || path === '/register';
      if (!isAuthPage) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
)

export default client

